import { type Context, createContext } from 'react';
import type { QueryHook } from 'react-query-kit';
import type { GooglePlace } from './GooglePlace';
import type { DistanceResponse, GooglePlacesApi } from './GooglePlacesApi';

const DUMMY_API: GooglePlacesApi = {
  lookup: (): QueryHook<GooglePlace> => {
    throw new Error('Function not implemented.');
  },
  distance: (): QueryHook<DistanceResponse> => {
    throw new Error('Function not implemented.');
  },
};

export const GooglePlacesContext: Context<GooglePlacesApi> = createContext(DUMMY_API);
